import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Presentation from './pages/Presentation'
import PreSelection from './pages/PreSelection'
import Confirmation from './pages/Confirmation'
import AdminPanel from './pages/AdminPanel'
import AdminSetup from './pages/AdminSetup'
import NotReady from './pages/NotReady'
import AdminLeitura from './pages/AdminLeitura'
import LeituraInscricao from './pages/LeituraInscricao'
import AdminLeituraInscricao from './pages/AdminLeituraInscricao'
import Perfil from './pages/Perfil'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Presentation />} />
        <Route path="/pre-selecao" element={<PreSelection />} />
        <Route path="/confirmacao" element={<Confirmation />} />
        <Route path="/nao-pronta" element={<NotReady />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/setup" element={<AdminSetup />} />
        <Route path="/admin/leitura" element={<AdminLeitura />} />
        <Route path="/inscricao" element={<LeituraInscricao />} />
        <Route path="/perfil" element={<Perfil />} />
        <Route path="/admin/leitura-inscricao" element={<AdminLeituraInscricao />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
